import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import useMediaQuery from 'Hooks/useMediaQuery';
import { cloneElement } from 'react';
import IconButton from 'Components/Atoms/IconButton/IconButton';
import OutlineClose from 'Components/Atoms/OutlineIcons/OutlineClose';

export default function Alert(props) {
    const { title, icon, description, className, actions, variant, classNameIcon, onClose, stacked } = props;
    const isDesktop = useMediaQuery('(min-width: 1024px)');

    const isPrimary = variant === 'primary';
    const isDanger = variant === 'danger';

    return (
        <div
            role="alert"
            className={cn(
                'relative grid grid-cols-[auto_1fr] gap-4 items-start bg-gray-50 text-dark-blue w-full p-3 shadow-2xs',
                isPrimary && 'bg-[#FFD5A3] shadow-none',
                className,
            )}
        >
            <div
                className={cn(
                    'size-11 flex items-center justify-center bg-white rounded-md',
                    isDanger && 'bg-danger/10',
                    classNameIcon,
                )}
            >
                {icon}
            </div>
            <div className={cn('flex flex-col items-start gap-2', !stacked && 'lg:flex-row lg:items-center')}>
                <div className="grow w-full">
                    <div className="flex items-start gap-2">
                        <div className="grow">
                            <div className={cn('font-semibold text-sm', isDanger && 'text-danger')}>{title}</div>
                            {description && <div className="text-[13px]">{description}</div>}
                        </div>
                        {onClose && (
                            <IconButton
                                icon={<OutlineClose />}
                                onClick={onClose}
                                variant="ghost"
                                className="-translate-y-[10px] lg:hidden"
                            />
                        )}
                    </div>
                </div>

                <div className="flex lg:flex-row-reverse gap-2">
                    {actions &&
                        actions.map((ActionButton) => {
                            return cloneElement(ActionButton, {
                                size: isDesktop ? 'default' : 'small',
                                className: cn('shadow-md', ActionButton.props.className),
                            });
                        })}
                </div>
                {onClose && (
                    <IconButton icon={<OutlineClose />} className="hidden lg:flex" onClick={onClose} variant="ghost" />
                )}
            </div>
        </div>
    );
}

Alert.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    icon: PropTypes.node,
    className: PropTypes.string,
    classNameIcon: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.node),
    variant: PropTypes.oneOf(['default', 'primary', 'danger']),
    onClose: PropTypes.func,
    // Keeps the actions below the text on desktop too
    stacked: PropTypes.bool,
};
